import BaseModel from "./BaseModel";
import UseStoreHandler from "@/composables/handlers/UseStoreHandler";

/**
 * SupportReason
 */
export default class SupportReason extends BaseModel {
  constructor({
    id,
    name,
    slug,
    active,
    en,
    pt,
    es,
    created_at,
    updated_at,
  }) {
    super();

    this.id = id || null;
    this.name = name || null;
    this.slug = slug || null;
    this.active = active !== undefined ? active : 1;
    this.en = en || null;
    this.pt = pt || null;
    this.es = es || null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
  }

  /**
   * Returns true if reason is active
   * @returns {Boolean}
   */
  isActive() {
    return this.active == 1;
  }

  /**
   * Returns true if this is the "other" reason
   * @returns {Boolean}
   */
  isOther() {
    return this.slug === 'other';
  }

  /**
   * Gets translated name
   * @returns {String}
   */
  getName() {
    const lang = UseStoreHandler.getContextStore().getLang;
    return this[lang] || this.en;
  }
}